/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Status of collateral verification
 */
export type CollateralVerificationStatus = typeof CollateralVerificationStatus[keyof typeof CollateralVerificationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollateralVerificationStatus = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
} as const;
